import { useState, useEffect } from 'react';
import { supabase } from '../utils/supabaseClient';
import { useCategoriesContext } from '../contexts/CategoriesContext';

export function useCategoryPage({ 
  primaryCategory,
  selectedCategoryId,
  category
}) {
  const [hasData, setHasData] = useState(true);
  const { 
    isLoading: categoriesLoading,
    categoryExists
  } = useCategoriesContext();

  // Verificar disponibilidad de datos
  useEffect(() => {
    if (!categoryExists(category)) {
      setHasData(false);
      return;
    }

    const checkDataAvailability = async () => {
      try {
        let query = supabase.from("cards").select("id").limit(1);

        if (selectedCategoryId !== 9) {
          query = query.eq("category_id", selectedCategoryId);
        }

        if (primaryCategory === "Launched") {
          query = query.eq("launched", true);
        }

        if (primaryCategory === "Trending") {
          const { data: topRanked } = await supabase
            .from("cards")
            .select("id")
            .order("rank", { ascending: false })
            .limit(20);

          if (topRanked?.length) {
            const topIds = topRanked.map(card => card.id);
            query = query.in("id", topIds);
          }
        }

        if (primaryCategory === "Just In") {
          const { data: recentCards } = await supabase
            .from("cards")
            .select("id")
            .order("addedtime", { ascending: false })
            .limit(20);

          if (recentCards?.length) {
            const recentIds = recentCards.map(card => card.id);
            query = query.in("id", recentIds);
          }
        }

        const { data } = await query;
        setHasData(Boolean(data?.length));
      } catch (error) {
        console.error("Error checking data availability:", error);
        setHasData(false);
      }
    };

    checkDataAvailability();
  }, [primaryCategory, selectedCategoryId, category, categoryExists]);

  return {
    hasData,
    isLoading: categoriesLoading
  };
}